var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"cell_number",attrs:{"type":"tel","id":"phone_number","name":"phone_number","placeholder":"Enter Phone Number"},on:{"keyup":function($event){return _vm.formatIntlTelInput()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }